export default __webpack_public_path__ + "static/media/goblin3.f6ef3c6f.png";